<div class="wrapper" *ngIf="organization">
  <div class="page-header">
    <div>
      <p class="section-kicker">Pilotage entreprise</p>
      <h1>Mon offre et mes parcours</h1>
      <p class="page-intro">
        Suivez votre offre, ajustez le nombre de collaborateurs et ajoutez des parcours complémentaires, en toute autonomie.
      </p>
    </div>
  </div>

  <div class="units-resume mobile-column gap margin-bottom-xl">
    <div class="units-resume-header column center-children base-padding">
      <div class="row gap margin-bottom center-children">
        <div class="text-primary-120">
          <app-icon type="crawn" />
        </div>
        <div class="text-primary text-xl cooper">{{ displayedUnits }}</div>
        <div class="cooper">crédit{{ displayedUnits ? 's' : '' }} disponible{{ displayedUnits ? 's' : '' }}</div>
      </div>
      <div class="text-primary-120 text-small">{{ creditInfo.orientationCall.label }}</div>
      <div class="text-primary-120 text-small">{{ creditInfo.speechTrain.label }}</div>
      <div class="text-primary-120 text-small">{{ creditInfo.coachingTrain.label }}</div>
    </div>
    <div class="mobile-column grow gap base-padding center-children space-between">
      <p class="grow contact-us" *ngIf="hasUnlimitedCredits; else standardCreditMessage">
        Votre formule {{ subscriptionPlanName }} inclut les crédits illimités.
      </p>
      <ng-template #standardCreditMessage>
        <p class="grow contact-us">
          C'est votre indicateur de référence, notamment si votre organisation est encore sur une ancienne formule.
        </p>
      </ng-template>
      <app-button type="button" icon="arrow-right" (onClick)="goToCompanyOffers()">Comparer les offres</app-button>
    </div>
  </div>

  <div class="offers-recommendation" *ngIf="recommendedOfferCard as recommendedOffer">
    <div class="offers-recommendation-copy">
      <p class="offers-recommendation-kicker">Aller plus loin</p>
      <h2>{{ recommendedOffer.planCode === 'wetalk-plus' ? 'We talk Plus' : recommendedOffer.planCode === 'wetalk-coach' ? 'We talk coach' : 'We talk Basic' }}</h2>
      <p>{{ recommendedOffer.summary }}</p>
      <p class="offers-recommendation-credit">{{ recommendedOffer.creditSummary }}</p>
    </div>
    <div class="offers-recommendation-actions">
      <app-button type="button" [outline]="true" (onClick)="goToCompanyOffers()">Comparer les offres</app-button>
    </div>
  </div>

  <div class="current-offer-grid">
    <div class="summary-card spotlight">
      <p class="section-kicker">Offre active</p>
      <h2>{{ currentOfferName }}</h2>
      <p class="summary-value">{{ currentAnnualAmountLabel }}</p>
      <p class="summary-note">Date de début : {{ organization.activeSubscription?.startsAt?.toLocaleDateString() || 'Non disponible' }}</p>
      <p class="summary-note">Fin d'abonnement : {{ organization.activeSubscription?.nextRenewalAt?.toLocaleDateString() || 'Non disponible' }}</p>
      <p class="summary-note">Nombre de collaborateurs : {{ organization.activeSubscription?.seatCount || 0 }} collaborateur{{ (organization.activeSubscription?.seatCount || 0) > 1 ? 's' : '' }}</p>
    </div>

    <div class="summary-card">
      <p class="section-kicker">Parcours inclus</p>
      <p class="metric">{{ currentIncludedJourneysRemaining }}</p>
      <p class="summary-note">à utiliser avant la fin de votre période d'abonnement</p>
    </div>

    <div class="summary-card">
      <p class="section-kicker">Parcours complémentaires</p>
      <p class="metric">{{ currentComplementaryJourneysRemaining }}</p>
      <p class="summary-note">Valables jusqu'au {{ currentOfferExpiryLabel }}</p>
    </div>

    <div class="summary-card">
      <p class="section-kicker">Tarif complémentaire</p>
      <p class="metric metric-price" *ngIf="currentComplementaryJourneyPriceLines as priceLines; else singleComplementaryPrice">
        <span class="metric-price-line">{{ priceLines[0] }}</span>
        <span class="metric-price-line">{{ priceLines[1] }}</span>
      </p>
      <ng-template #singleComplementaryPrice>
        <p class="metric metric-price">{{ currentComplementaryJourneyPriceLabel }}</p>
      </ng-template>
      <p class="summary-note">(1 parcours = 10 crédits)</p>
    </div>
  </div>

  <div class="management-grid" [ngClass]="{ 'management-grid--single-column': !shouldShowOfferManagementSection }">
    <section class="panel" *ngIf="shouldShowOfferManagementSection">
      <div class="panel-header">
        <div>
          <p class="section-kicker">{{ hasActiveManagedOffer ? 'Evolution d’offre' : 'Activation ou remplacement' }}</p>
          <h2>{{ hasActiveManagedOffer ? 'Faire évoluer mon offre' : 'Activer mon offre' }}</h2>
        </div>
      </div>

      <ng-template #loadingOfferCatalog>
        <p class="empty-state">Chargement du catalogue des offres…</p>
      </ng-template>

      <div class="inline-alert" *ngIf="hasActiveManagedOffer && !isAdminViewing">
        Un récapitulatif s’affiche avant validation. Les évolutions à hausse s’activent après paiement, les baisses et résiliations à l’échéance.
      </div>

      <div class="checkout-banner checkout-banner--refunded" *ngIf="latestOfferBillingFeedback as refundedOfferRecord">
        <div class="banner-copy">
          <p class="section-kicker">Information synchronisée</p>
          <h3>{{ getBillingRecordFeedbackTitle(refundedOfferRecord) }}</h3>
          <p>{{ getBillingRecordSummary(refundedOfferRecord) }}</p>
        </div>
      </div>

      <ng-container *ngIf="hasActiveManagedOffer && !isAdminViewing">
        <div class="checkout-banner" *ngIf="activeSubscriptionChangeRequest">
          <div>
            <p class="section-kicker">Demande en cours</p>
            <h3>{{ activeSubscriptionChangeStatusLabel }}</h3>
            <p>{{ activeSubscriptionChangeDescription }}</p>
          </div>
          <div class="banner-actions" *ngIf="activeSubscriptionChangeRequestCheckoutUrl || canCancelActiveSubscriptionChangeRequest">
            <app-button
              *ngIf="canCancelActiveSubscriptionChangeRequest"
              type="button"
              [outline]="true"
              [secondary]="true"
              [disabled]="isSubmittingSubscriptionChange"
              (onClick)="cancelActiveSubscriptionChangeRequest()">
              {{ cancelActiveSubscriptionChangeRequestLabel }}
            </app-button>
            <app-button
              *ngIf="activeSubscriptionChangeRequestCheckoutUrl"
              type="button" [outline]="true" [primary]="true" (onClick)="copyCheckoutUrl(activeSubscriptionChangeRequestCheckoutUrl)">
              Copier le lien
            </app-button>
            <app-button
              *ngIf="activeSubscriptionChangeRequestCheckoutUrl"
              type="button" [primary]="true" (onClick)="openCheckout(activeSubscriptionChangeRequestCheckoutUrl)">
              Reprendre le paiement
            </app-button>
          </div>
        </div>

        <div *ngIf="canRequestSubscriptionChange">
          <div class="form-grid form-grid--two-columns" *ngIf="!loadingCatalog; else loadingOfferCatalog">
            <app-input
              title="Offre cible"
              [dropdownData]="managedFormulaNames"
              [inputField]="managedSubscriptionPlanControl"
            ></app-input>
            <app-input
              title="Nombre de collaborateurs"
              type="number"
              [inputField]="managedSubscriptionSeatCountControl"
              placeholder="1"
              [min]="1"
            ></app-input>
          </div>

          <p class="summary-note">Paliers de tarification : jusqu’à 50, de 51 à 500, puis 501 et plus.</p>

          <div class="subscription-change-actions">
            <app-button
              type="button"
              [primary]="true"
              [disabled]="!canSimulateSelectedUpgrade || isSubmittingSubscriptionChange"
              (onClick)="onSimulateUpgrade()"
            >
              Monter en gamme
            </app-button>
            <app-button
              type="button"
              [outline]="true"
              [primary]="true"
              [disabled]="!canSimulateSeatIncrease || isSubmittingSubscriptionChange"
              (onClick)="onSimulateSeatIncrease()"
            >
              Augmenter les sièges
            </app-button>
            <app-button
              type="button"
              [outline]="true"
              [secondary]="true"
              [disabled]="!canSimulateSelectedDowngrade || isSubmittingSubscriptionChange"
              (onClick)="onSimulateDowngrade()"
            >
              Descendre en gamme
            </app-button>
            <app-button
              type="button"
              [outline]="true"
              [secondary]="true"
              [disabled]="!canSimulateSeatDecrease || isSubmittingSubscriptionChange"
              (onClick)="onSimulateSeatDecrease()"
            >
              Réduire les sièges
            </app-button>
            <app-button
              type="button"
              [outline]="true"
              [secondary]="true"
              [disabled]="isSubmittingSubscriptionChange"
              (onClick)="onScheduleCancellation()"
            >
              Résilier
            </app-button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!hasActiveManagedOffer || isAdminViewing">
        <div class="checkout-banner" *ngIf="isAdminViewing && activeSubscriptionChangeRequest">
          <div>
            <p class="section-kicker">Demande en cours</p>
            <h3>{{ activeSubscriptionChangeStatusLabel }}</h3>
            <p>{{ activeSubscriptionChangeDescription }}</p>
          </div>
          <div class="banner-actions" *ngIf="canReviewSubscriptionChangeRequest">
            <app-button
              type="button"
              [outline]="true"
              [secondary]="true"
              [disabled]="isSubmittingSubscriptionChange"
              (onClick)="rejectActiveSubscriptionChangeRequest()">
              Refuser
            </app-button>
            <app-button
              type="button"
              [primary]="true"
              [disabled]="isSubmittingSubscriptionChange"
              (onClick)="approveActiveSubscriptionChangeRequest()">
              Approuver
            </app-button>
          </div>
          <div class="banner-actions" *ngIf="!canReviewSubscriptionChangeRequest && activeSubscriptionChangeRequestCheckoutUrl">
            <app-button type="button" [outline]="true" [primary]="true" (onClick)="copyCheckoutUrl(activeSubscriptionChangeRequestCheckoutUrl)">
              Copier le lien
            </app-button>
            <app-button type="button" [primary]="true" (onClick)="openCheckout(activeSubscriptionChangeRequestCheckoutUrl)">
              Reprendre le paiement
            </app-button>
          </div>
        </div>

        <div class="checkout-banner" *ngIf="pendingSubscriptionCheckoutUrl">
          <div>
            <p class="section-kicker">Action requise</p>
            <h3>Un paiement d’activation est déjà en attente</h3>
            <p>Reprenez le règlement ou copiez le lien sans recréer un nouveau flux.</p>
          </div>
          <div class="banner-actions">
            <app-button type="button" [outline]="true" [primary]="true" (onClick)="copyCheckoutUrl(pendingSubscriptionCheckoutUrl)">
              Copier le lien
            </app-button>
            <app-button type="button" [primary]="true" (onClick)="openCheckout(pendingSubscriptionCheckoutUrl)">
              Reprendre le paiement
            </app-button>
          </div>
        </div>

        <div
          [ngClass]="isAdminViewing ? 'form-grid' : 'form-grid form-grid--two-columns'"
          *ngIf="!loadingCatalog; else loadingOfferCatalog">
          <app-input
            title="Offre"
            [dropdownData]="managedFormulaNames"
            [inputField]="managedSubscriptionPlanControl"
          ></app-input>
          <app-input
            *ngIf="isAdminViewing"
            title="Date de départ"
            type="date"
            [inputField]="managedSubscriptionStartsAtControl"
          ></app-input>
          <app-input
            title="Nombre de collaborateurs"
            type="number"
            [inputField]="managedSubscriptionSeatCountControl"
            placeholder="1"
            [min]="1"
          ></app-input>
        </div>

        <p class="summary-note">Paliers de tarification : jusqu’à 50, de 51 à 500, puis 501 et plus.</p>

        <div class="preview-card">
          <p class="section-kicker">Récapitulatif avant confirmation</p>
          <div class="preview-grid">
            <div>
              <span class="preview-label">Offre choisie</span>
              <strong>{{ selectedManagedOfferName }}</strong>
            </div>
            <div>
              <span class="preview-label">Nombre de collaborateurs</span>
              <strong>{{ selectedSeatCount }} collaborateur{{ selectedSeatCount > 1 ? 's' : '' }}</strong>
            </div>
            <div>
              <span class="preview-label">Montant annuel</span>
              <strong>{{ selectedAnnualPricePerSeatCents ? formatCurrency(selectedAnnualAmountCents) : 'Sans abonnement annuel' }}</strong>
            </div>
            <div>
              <span class="preview-label">Parcours inclus</span>
              <strong>{{ selectedIncludedJourneysCount }}</strong>
            </div>
            <div>
              <span class="preview-label">Prix du parcours complémentaire</span>
              <strong>{{ selectedComplementaryJourneyPriceCents ? formatCurrency(selectedComplementaryJourneyPriceCents) + ' / parcours' : 'Non disponible' }}</strong>
            </div>
            <div>
              <span class="preview-label">Fin d'abonnement</span>
              <strong>{{ selectedOfferNextRenewalLabel }}</strong>
            </div>
          </div>

          <p class="inline-alert" *ngIf="!isAdminViewing">
            Votre nouvel abonnement remplacera l'offre actuelle. Le montant sera ajusté au prorata et confirmé avant validation.
          </p>
        </div>

        <div class="panel-action">
          <app-button
            type="button"
            [primary]="true"
            [disabled]="!canSaveManagedOffer || isSavingOffer"
            (onClick)="saveManagedOffer()"
          >
            {{ isSavingOffer ? 'Préparation…' : offerActionLabel }}
          </app-button>
        </div>
      </ng-container>
    </section>

    <section class="panel">
      <div class="panel-header">
        <div>
          <p class="section-kicker">Achat complémentaire</p>
          <h2>Ajouter des parcours</h2>
        </div>
      </div>

      <p class="empty-state" *ngIf="!hasActiveManagedOffer">
        Activez d'abord une offre pour acheter des parcours complémentaires.
      </p>

      <ng-container *ngIf="hasActiveManagedOffer">
        <div class="preview-card preview-card--spotlight">
          <p class="section-kicker">Récapitulatif avant confirmation</p>
          <div class="preview-grid">
            <div>
              <span class="preview-label">Quantité</span>
              <strong>{{ selectedComplementaryJourneyQuantity }} parcours</strong>
            </div>
            <div>
              <span class="preview-label">Type</span>
              <strong>{{ selectedComplementaryJourneyType === 'coaching' ? 'Coaching en groupe' : shouldChooseComplementaryJourneyType ? 'Parole en groupe' : 'Parcours complémentaire' }}</strong>
            </div>
            <div>
              <span class="preview-label">Prix unitaire</span>
              <strong>{{ selectedComplementaryJourneyUnitPriceCents ? formatCurrency(selectedComplementaryJourneyUnitPriceCents) + ' / parcours' : 'Non disponible' }}</strong>
            </div>
            <div>
              <span class="preview-label">Montant</span>
              <strong>{{ formatCurrency(complementaryJourneysTotalCents) }}</strong>
            </div>
            <div>
              <span class="preview-label">Validité</span>
              <strong>Jusqu'au {{ currentOfferExpiryLabel }}</strong>
            </div>
            <div>
              <span class="preview-label">Rappel</span>
              <strong>(1 parcours = 10 crédits)</strong>
            </div>
          </div>
        </div>

        <div class="checkout-banner checkout-banner--refunded" *ngIf="latestComplementaryBillingFeedback as refundedComplementaryRecord">
          <div class="banner-copy">
            <p class="section-kicker">Information synchronisée</p>
            <h3>{{ getBillingRecordTitle(refundedComplementaryRecord) }} remboursé</h3>
            <p>{{ getBillingRecordSummary(refundedComplementaryRecord) }}</p>
          </div>
        </div>

        <div class="checkout-banner" *ngIf="pendingComplementaryJourneysCheckoutUrl">
          <div>
            <p class="section-kicker">Action requise</p>
            <h3>Le paiement de {{ pendingComplementaryJourneysLabel }} est déjà en attente</h3>
            <p>Reprenez le règlement ou copiez le lien sans recréer un nouveau flux.</p>
          </div>
          <div class="banner-actions">
            <app-button type="button" [outline]="true" [primary]="true" (onClick)="copyCheckoutUrl(pendingComplementaryJourneysCheckoutUrl)">
              Copier le lien
            </app-button>
            <app-button type="button" [primary]="true" (onClick)="openCheckout(pendingComplementaryJourneysCheckoutUrl)">
              Reprendre le paiement
            </app-button>
          </div>
        </div>

        <div class="form-grid compact complementary-form">
          <app-input
            *ngIf="shouldChooseComplementaryJourneyType"
            title="Type de parcours"
            type="dropdown"
            [dropdownData]="complementaryJourneyTypeOptions"
            [inputField]="complementaryJourneyTypeControl"
          ></app-input>
          <app-input
            title="Nombre de parcours"
            type="number"
            [inputField]="complementaryJourneysQuantityControl"
            placeholder="1"
            [min]="1"
          ></app-input>
        </div>

        <div class="panel-action">
          <app-button
            type="button"
            [secondary]="true"
            [disabled]="!canPurchaseComplementaryJourneys || isPurchasingJourneys"
            (onClick)="purchaseComplementaryJourneys()"
          >
            {{ isPurchasingJourneys ? 'Préparation…' : 'Confirmer l’achat' }}
          </app-button>
        </div>
      </ng-container>
    </section>
  </div>

  <section class="panel">
    <div class="panel-header">
      <div>
        <p class="section-kicker">Mon historique</p>
        <h2>Mes factures et paiements</h2>
      </div>
    </div>

    <div class="history-list billing-history-list" *ngIf="billingRecords.length; else noBillingHistory">
      <div class="history-item history-item--billing" *ngFor="let record of billingRecords; trackBy: trackBillingRecord">
        <div class="history-copy">
          <div class="history-title-row">
            <strong>{{ getBillingRecordTitle(record) }}</strong>
            <span
              class="history-status-pill"
              [ngClass]="'history-status-pill--' + getBillingRecordStatusTone(record)">
              {{ getBillingRecordStatusLabel(record) }}
            </span>
          </div>
          <p>{{ getBillingRecordSummary(record) }}</p>
          <div class="history-inline-meta">
            <span>{{ getBillingRecordPrimaryDate(record) }}</span>
            <span *ngFor="let meta of getBillingRecordMeta(record)">{{ meta }}</span>
          </div>
        </div>
      </div>
    </div>

    <ng-template #noBillingHistory>
      <p class="empty-state">Aucun document de facturation Sellsy pour le moment.</p>
    </ng-template>
  </section>

  <section class="panel">
    <div class="panel-header">
      <div>
        <p class="section-kicker">Mes offres passées</p>
        <h2>Suivi de mon offre</h2>
      </div>
    </div>

    <div class="history-list" *ngIf="subscriptionsHistory.length; else noSubscriptionsHistory">
      <div class="history-item" *ngFor="let subscription of subscriptionsHistory">
        <div>
          <strong>{{ getSubscriptionDisplayName(subscription) }}</strong>
          <p>
            Début : {{ subscription.startsAt.toLocaleDateString() }}
            | Fin d'abonnement : {{ subscription.nextRenewalAt.toLocaleDateString() }}
          </p>
        </div>
        <div class="history-meta">
          <span>{{ subscription.seatCount }} collaborateur{{ subscription.seatCount > 1 ? 's' : '' }}</span>
          <span [class.cancelled]="subscription.status === 'cancelled'">
            {{ subscription.status === 'active' ? 'Active' : 'Remplacée' }}
          </span>
        </div>
      </div>
    </div>

    <ng-template #noSubscriptionsHistory>
      <p class="empty-state">Aucun historique d'offre pour le moment.</p>
    </ng-template>
  </section>

  <section class="panel">
    <div class="panel-header">
      <div>
        <p class="section-kicker">Suivi de mes parcours</p>
        <h2>Détail de mes parcours</h2>
      </div>
      <app-button type="button" [outline]="true" icon="upload" (onClick)="downloadCsv()">
        Exporter
      </app-button>
    </div>

    <app-table (sort)="sortTransactions($event)" [tableConfig]="headerColumns" [items]="transactions"></app-table>
  </section>
</div>
